import isPostalCode from 'validator/es/lib/isPostalCode';

type PostalLocale = Parameters<typeof isPostalCode>[1];

export function validatePostcode(value: string, countries?: readonly string[]): boolean {
  if (countries?.length) {
    return countries.some(country => {
      try {
        return isPostalCode(value, country.toUpperCase() as PostalLocale);
      } catch {
        return false;
      }
    });
  }

  return isPostalCode(value, 'any' as PostalLocale) || isPostalCode(value, 'FR');
}
